(function () {
    'ngInject';

    angular.module('app.shared.services').factory('TagAPIService', tagAPIService);

    function tagAPIService(HttpService) {
        function getTags() {
            return HttpService.get('/Tag/GetTags');
        }

        return {
            getTags: getTags
        };
    }
})();
